import MEAL_ICON from "../../assets/images/meal-icon.png";
import BAGGAGE_ICON from "../../assets/images/baggage-icon.png";
import SEAT_ICON from "../../assets/images/seat-icon.png";
import WHEELCHAIR_ICON from "../../assets/images/wheelchairicon.png";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import Loading from "../../components/spinner/Loading";
import AddonSelection from "./AddonSelection";
import { settabIndex } from "./reviewbookingSlice";
import { FaEdit } from "react-icons/fa";
import { getTotalSSRCount } from "../../_helpers/ssrUtils";

const AddOnsCard = ({
  travellers,
  alltravellers,
  // setTravellerConfirm,
  // setProcessContinue,
  toggleTotalSeatSelection,
  toggleMealSelection,
  toggleBaggageSelection,
  toggleWheelChairSelection,
  totalSeats,
  selectedmealPerSegment,
  selectedBaggagePerSegment,
  selectedWheelChairPerSegment,
  totalMealAmount,
  totalBaggageAmount,
  totalWheelChairAmount,
  totalSeatsAmount,
  isAddonShow,
}: {
  travellers: any[];
  alltravellers: any[];
  selectedmealPerSegment: {
    [index: number]: any[];
  };
  selectedBaggagePerSegment: {
    [index: number]: any[];
  };
  selectedWheelChairPerSegment: {
    [index: number]: any[];
  };
  totalSeatsAmount: number;
  totalMealAmount: number;
  totalBaggageAmount: number;
  totalWheelChairAmount: number;
  // setTravellerConfirm: (confirm: boolean) => void;
  // setProcessContinue: (confirm: boolean) => void;
  toggleTotalSeatSelection: (seat: any, index: number) => void;
  toggleMealSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  toggleBaggageSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  toggleWheelChairSelection: (
    ssr: any,
    passengerIndex: number,
    segmentIndex: number
  ) => void;
  totalSeats: any[];
  isAddonShow: boolean;
}) => {
  const dispatch = useAppDispatch();
  const seatmapData = useAppSelector(
    (state) => state.reviewbooking.seatmapData
  );

  const ssrData = useAppSelector((state) => state.reviewbooking.ssrData);

  const seatmapLoading = useAppSelector(
    (state) => state.reviewbooking.seatmapLoading
  );

  const ssrLoading = useAppSelector((state) => state.reviewbooking.ssrLoading);

  const mealCount = getTotalSSRCount(selectedmealPerSegment);
  const baggageCount = getTotalSSRCount(selectedBaggagePerSegment);
  const wheelchairCount = getTotalSSRCount(selectedWheelChairPerSegment);

  return (
    <>
      <div className="addons-main-card">
        <h4 className="mb-3">Addon Services</h4>
        <div className="addons-body position-relative">
          <Loading loading={seatmapLoading || ssrLoading} />
          {isAddonShow && !seatmapLoading && !ssrLoading ? (
            ssrData?.length > 0 || seatmapData?.length > 0 ? (
              <>
                {ssrData?.length > 0 && (
                  <>
                    <div
                      className="addon-card"
                      data-bs-toggle="modal"
                      data-bs-target="#addon-selection"
                      onClick={() => dispatch(settabIndex(2))}
                    >
                      {mealCount > 0 && (
                        <div className="ssr-selected">
                          <span className="selected-count">
                            {mealCount} Meal Selected
                          </span>
                          <span className="selected-amount">
                            {`₹ ${totalMealAmount}`}
                            <FaEdit
                              className="btn-edit"
                              style={{ fontSize: 16 }}
                            />
                          </span>
                        </div>
                      )}
                      <img
                        src={MEAL_ICON}
                        alt="Add Meals"
                        className="addon-icon"
                      />
                      <div className="addon-text">Add Meals</div>
                    </div>
                    <div
                      className="addon-card"
                      data-bs-toggle="modal"
                      data-bs-target="#addon-selection"
                      onClick={() => dispatch(settabIndex(3))}
                    >
                      {baggageCount > 0 && (
                        <div className="ssr-selected">
                          <span className="selected-count">
                            {baggageCount} Baggage Selected
                          </span>
                          <span className="selected-amount">
                            {`₹ ${totalBaggageAmount}`}
                            <FaEdit
                              className="btn-edit"
                              style={{ fontSize: 16 }}
                            />
                          </span>
                        </div>
                      )}
                      <img
                        src={BAGGAGE_ICON}
                        alt="Add Baggage"
                        className="addon-icon"
                      />
                      <div className="addon-text">Add Baggage</div>
                    </div>
                  </>
                )}
                {seatmapData?.length > 0 && (
                  <div
                    className="addon-card"
                    data-bs-toggle="modal"
                    data-bs-target="#addon-selection"
                    onClick={() => dispatch(settabIndex(1))}
                  >
                    {totalSeats?.length > 0 && (
                      <div className="ssr-selected">
                        <span className="selected-count">
                          {totalSeats?.length} Seat Selected
                        </span>
                        <span className="selected-amount">
                          {`₹ ${totalSeatsAmount}`}
                          <FaEdit
                            className="btn-edit"
                            style={{ fontSize: 16 }}
                          />
                        </span>
                      </div>
                    )}
                    <img
                      src={SEAT_ICON}
                      alt="Seat Selection"
                      className="addon-icon"
                    />
                    <div className="addon-text">Seat Selection</div>
                  </div>
                )}
                {ssrData?.length > 0 && (
                  <>
                    <div
                      className="addon-card"
                      data-bs-toggle="modal"
                      data-bs-target="#addon-selection"
                      onClick={() => dispatch(settabIndex(4))}
                    >
                      {wheelchairCount > 0 && (
                        <div className="ssr-selected">
                          <span className="selected-count">
                            {wheelchairCount} Wheel chair Selected
                          </span>
                          <span className="selected-amount">
                            {`₹ ${totalWheelChairAmount}`}
                            <FaEdit
                              className="btn-edit"
                              style={{ fontSize: 16 }}
                            />
                          </span>
                        </div>
                      )}
                      <img
                        src={WHEELCHAIR_ICON}
                        alt="Wheel Chair"
                        className="addon-icon"
                      />
                      <div className="addon-text">Wheel Chair</div>
                    </div>
                  </>
                )}
              </>
            ) : (
              <h6>No Addons Available!</h6>
            )
          ) : (
            <h6>Select the Travellers first!</h6>
          )}
        </div>
      </div>
      <div
        className="modal fade"
        id="addon-selection"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex={-1}
        aria-labelledby="addon-popup"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          style={{ width: "900px", alignItems: "end", maxWidth: "90vw" }}
        >
          <div className="modal-content addon-modal-content">
            <div className="modal-header addon-modal-header">
              <h4 className="modal-title fs-5" id="addon-popup">
                Addon Services
              </h4>
              <button
                type="button"
                className="btn-close addon-close-btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body travel-form-detail p-0">
              {/* {seatmapData?.length > 0 && ( */}
              <AddonSelection
                travellers={travellers}
                alltravellers={alltravellers}
                // setTravellerConfirm={setTravellerConfirm}
                // setProcessContinue={setProcessContinue}
                toggleTotalSeatSelection={toggleTotalSeatSelection}
                toggleMealSelection={toggleMealSelection}
                toggleBaggageSelection={toggleBaggageSelection}
                toggleWheelChairSelection={toggleWheelChairSelection}
                selectedmealPerSegment={selectedmealPerSegment}
                selectedBaggagePerSegment={selectedBaggagePerSegment}
                selectedWheelChairPerSegment={selectedWheelChairPerSegment}
                totalSeats={totalSeats}
              />
              {/* )} */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOnsCard;
